module.exports = __webpack_public_path__ + "media/src/images/icon__twitter--dark-d9dc8bd48e64bb9b27173ed43134056d.png";